// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + "mv-reviews" + ".chunk." + "4e75a" + ".css";
};